type ITodoInfo = ITodo.IResponse.ITodoInfo;

export const titleColumn = {
  dataIndex: 'title',
  slots: { title: 'todoTitle' },
  ellipsis: true,
  width: '16%',
  scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    customRender: 'todo',
  },
  onFilter: (value: string, record: ITodoInfo) => {
    return record.title.toString().toLowerCase().includes(value.toLowerCase());
  },
};
export const moduleColumn = {
  dataIndex: 'moduleTitle',
  slots: { title: 'moduleTitle' },
  width: '15%',
  ellipsis: true,
  scopedSlots: {
    customRender: 'module',
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
  },
  onFilter: (value: string, record: ITodoInfo) => {
    return record.moduleTitle
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase());
  },
};
export const dueColumn = {
  dataIndex: 'due',
  slots: { title: 'dueTitle' },
  scopedSlots: { customRender: 'due' },
  width: '8%',
  align: 'center',
  sorter: (a: ITodoInfo, b: ITodoInfo) => {
    return new Date(a.due).valueOf() - new Date(b.due).valueOf();
  },
};
export const manDayColumn = {
  dataIndex: 'manDay',
  slots: { title: 'manDayTitle' },
  width: '5%',
  align: 'center',
  sorter: (a: ITodoInfo, b: ITodoInfo) => a.manDay - b.manDay,
};
export const isBonusColumn = {
  dataIndex: 'isBonus',
  slots: { title: 'bonusTitle' },
  scopedSlots: { customRender: 'bonus' },
  width: '8%',
  align: 'center',
  filters: [
    { text: 'Yes', value: 'Yes' },
    { text: 'No', value: 'No' },
  ],
  onFilter: (value: string, record: ITodoInfo) =>
    (value === 'Yes') === record.isBonus,
};
